"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.issueThumbnailFieldUnmounted = exports.issueThumbnailFieldMounted = exports.issueSnapshotUploadSuccess = exports.issueSnapshotUploadStart = exports.issueSnapshotMarkingUpStart = exports.issueSnapshotMarkingUpEnd = exports.issueSnapshotFailure = exports.issueSnapshotDownloadSuccess = exports.issueSnapshotDownloadStart = exports.issueSnapshotCaptureStart = exports.getShouldFetchSnapshot = exports.getIssueSnapshotUrl = exports.getIssueSnapshotStatus = exports.getIssueSnapshot = exports.getIsPersistingIssueSnapshot = exports.getIsIssueThumbnailFieldMounted = exports.getIsIssueSnapshotWithMarkups = exports.getIsCapturingIssueSnapshot = exports.getIsAnySnapshotInProgress = exports.fetchIssueSnapshotAction = exports.SnapshotsStatus = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _some = _interopRequireDefault(require("lodash/some"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let SnapshotsStatus = exports.SnapshotsStatus = /*#__PURE__*/function (SnapshotsStatus) {
  SnapshotsStatus["None"] = "none";
  SnapshotsStatus["Capturing"] = "capturing";
  SnapshotsStatus["Uploading"] = "uploading";
  SnapshotsStatus["Persisted"] = "persisted";
  SnapshotsStatus["Downloading"] = "downloading";
  return SnapshotsStatus;
}({});
const initialState = {
  snapshotMap: {}
};
const issueSnapshotsSlice = (0, _toolkit.createSlice)({
  name: "issueSnapshots",
  initialState,
  reducers: {
    issueSnapshotCaptureStart: (state, action) => {
      const snapshotFromMemory = state.snapshotMap[action.payload.issueId];
      if (snapshotFromMemory !== null && snapshotFromMemory !== void 0 && snapshotFromMemory.url) {
        // We want to work with the snapshotUrl from OSS, not the one from memory
        URL.revokeObjectURL(snapshotFromMemory.url);
      }
      state.snapshotMap[action.payload.issueId] = {
        status: SnapshotsStatus.Capturing,
        flowId: action.payload.flowId
      };
    },
    issueSnapshotUploadStart: (state, action) => {
      var _action$payload$hasMa;
      const snapshotFromMemory = state.snapshotMap[action.payload.issueId];
      if (snapshotFromMemory !== null && snapshotFromMemory !== void 0 && snapshotFromMemory.flowId && snapshotFromMemory.flowId !== action.payload.flowId) {
        return;
      }
      state.snapshotMap[action.payload.issueId] = {
        ...snapshotFromMemory,
        status: SnapshotsStatus.Uploading,
        url: URL.createObjectURL(action.payload.snapshotBlob),
        hasMarkups: (_action$payload$hasMa = action.payload.hasMarkups) !== null && _action$payload$hasMa !== void 0 ? _action$payload$hasMa : false,
        flowId: action.payload.flowId
      };
    },
    issueSnapshotUploadSuccess: (state, action) => {
      var _action$payload$hasMa2;
      const snapshotFromMemory = state.snapshotMap[action.payload.issueId];
      if (snapshotFromMemory !== null && snapshotFromMemory !== void 0 && snapshotFromMemory.url) {
        // We want to work with the snapshotUrl from OSS, not the one from memory
        URL.revokeObjectURL(snapshotFromMemory.url);
      }
      if (action.payload.flowId && (snapshotFromMemory === null || snapshotFromMemory === void 0 ? void 0 : snapshotFromMemory.flowId) !== action.payload.flowId) {
        return;
      }
      state.snapshotMap[action.payload.issueId] = {
        ...snapshotFromMemory,
        status: SnapshotsStatus.Persisted,
        url: action.payload.snapshotUrl,
        urn: action.payload.snapshotUrn,
        hasMarkups: (_action$payload$hasMa2 = action.payload.hasMarkups) !== null && _action$payload$hasMa2 !== void 0 ? _action$payload$hasMa2 : false,
        flowId: undefined,
        // The flow ends here
        updatedAt: Date.now()
      };
    },
    issueSnapshotDownloadStart: (state, action) => {
      const snapshotFromMemory = state.snapshotMap[action.payload.issueId];
      state.snapshotMap[action.payload.issueId] = {
        // should keep the previous url & urn to avoid flickering
        ...snapshotFromMemory,
        status: SnapshotsStatus.Downloading,
        hasMarkups: action.payload.hasMarkups,
        flowId: undefined // ready to start a new flow
      };
    },
    issueSnapshotDownloadSuccess: (state, action) => {
      const snapshotFromMemory = state.snapshotMap[action.payload.issueId];
      if (!snapshotFromMemory) {
        return;
      }
      state.snapshotMap[action.payload.issueId] = {
        ...snapshotFromMemory,
        status: SnapshotsStatus.Persisted,
        url: action.payload.snapshotUrl,
        urn: action.payload.snapshotUrn,
        updatedAt: Date.now()
      };
    },
    issueSnapshotMarkingUpStart: (state, action) => {
      const snapshot = state.snapshotMap[action.payload.issueId];
      if (snapshot) {
        snapshot.markingUp = true;
      }
    },
    issueSnapshotMarkingUpEnd: (state, action) => {
      const snapshot = state.snapshotMap[action.payload.issueId];
      if (snapshot) {
        snapshot.markingUp = false;
        if (action.payload.snapshotBlob) {
          snapshot.flowId = undefined; // clear flow id to start a new flow of uploading
        }
      }
    },
    issueSnapshotFailure: (state, action) => {
      const snapshot = state.snapshotMap[action.payload.issueId];
      if (snapshot !== null && snapshot !== void 0 && snapshot.url) {
        URL.revokeObjectURL(snapshot.url);
      }
      delete state.snapshotMap[action.payload.issueId];
    },
    issueThumbnailFieldMounted: (state, action) => {
      let snapshot = state.snapshotMap[action.payload.issueId];
      if (!snapshot) {
        snapshot = state.snapshotMap[action.payload.issueId] = {
          status: SnapshotsStatus.None
        };
      }
      snapshot.mounted = true;
    },
    issueThumbnailFieldUnmounted: (state, action) => {
      let snapshot = state.snapshotMap[action.payload.issueId];
      if (!snapshot) {
        snapshot = state.snapshotMap[action.payload.issueId] = {
          status: SnapshotsStatus.None
        };
      }
      snapshot.mounted = false;
    }
  }
});
const {
  issueSnapshotCaptureStart,
  issueSnapshotUploadStart,
  issueSnapshotUploadSuccess,
  issueSnapshotFailure,
  issueSnapshotMarkingUpStart,
  issueSnapshotMarkingUpEnd,
  issueThumbnailFieldMounted,
  issueThumbnailFieldUnmounted,
  issueSnapshotDownloadStart,
  issueSnapshotDownloadSuccess
} = issueSnapshotsSlice.actions;
exports.issueSnapshotDownloadSuccess = issueSnapshotDownloadSuccess;
exports.issueSnapshotDownloadStart = issueSnapshotDownloadStart;
exports.issueThumbnailFieldUnmounted = issueThumbnailFieldUnmounted;
exports.issueThumbnailFieldMounted = issueThumbnailFieldMounted;
exports.issueSnapshotMarkingUpEnd = issueSnapshotMarkingUpEnd;
exports.issueSnapshotMarkingUpStart = issueSnapshotMarkingUpStart;
exports.issueSnapshotFailure = issueSnapshotFailure;
exports.issueSnapshotUploadSuccess = issueSnapshotUploadSuccess;
exports.issueSnapshotUploadStart = issueSnapshotUploadStart;
exports.issueSnapshotCaptureStart = issueSnapshotCaptureStart;
const fetchIssueSnapshotAction = _ref => {
  let {
    issue,
    onSuccess,
    onError
  } = _ref;
  return async (dispatch, getState, _ref2) => {
    var _issue$snapshotHasMar;
    let {
      sdk
    } = _ref2;
    if (!issue.snapshotUrn) {
      return;
    }
    dispatch(issueSnapshotDownloadStart({
      issueId: issue.id,
      hasMarkups: (_issue$snapshotHasMar = issue.snapshotHasMarkups) !== null && _issue$snapshotHasMar !== void 0 ? _issue$snapshotHasMar : false
    }));
    try {
      const downloadLink = await sdk.Oss.getDownloadLink(issue.snapshotUrn);
      dispatch(issueSnapshotDownloadSuccess({
        issueId: issue.id,
        snapshotUrl: downloadLink.url,
        snapshotUrn: issue.snapshotUrn
      }));
      onSuccess === null || onSuccess === void 0 || onSuccess(downloadLink.url);
    } catch (e) {
      dispatch(issueSnapshotFailure({
        issueId: issue.id
      }));
      onError === null || onError === void 0 || onError();
    }
  };
};
exports.fetchIssueSnapshotAction = fetchIssueSnapshotAction;
const reducer = exports.reducer = issueSnapshotsSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueSnapshotsSlice.name;
const getIssueSnapshotsState = state => {
  return state[STATE_KEY];
};
const getIssueSnapshot = exports.getIssueSnapshot = (0, _toolkit.createSelector)(getIssueSnapshotsState, snapshotsState => issueId => {
  if (!issueId) {
    return undefined;
  }
  const snapshot = snapshotsState.snapshotMap[issueId];
  if (!snapshot) {
    return undefined;
  }
  return snapshot;
});
const getIssueSnapshotUrl = exports.getIssueSnapshotUrl = (0, _toolkit.createSelector)(getIssueSnapshot, issueSnapshotGetter => issueId => {
  const snapshot = issueSnapshotGetter(issueId);
  return snapshot === null || snapshot === void 0 ? void 0 : snapshot.url;
});
const getIssueSnapshotStatus = exports.getIssueSnapshotStatus = (0, _toolkit.createSelector)(getIssueSnapshot, issueSnapshotGetter => issueId => {
  const snapshot = issueSnapshotGetter(issueId);
  return snapshot === null || snapshot === void 0 ? void 0 : snapshot.status;
});
const getIsCapturingIssueSnapshot = exports.getIsCapturingIssueSnapshot = (0, _toolkit.createSelector)(getIssueSnapshotStatus, issueSnapshotStatusGetter => issueId => {
  const issueSnapshotStatus = issueSnapshotStatusGetter(issueId);
  return issueSnapshotStatus === SnapshotsStatus.Capturing;
});
const getIsIssueSnapshotWithMarkups = exports.getIsIssueSnapshotWithMarkups = (0, _toolkit.createSelector)(getIssueSnapshot, issueSnapshotGetter => issueId => {
  var _snapshot$hasMarkups;
  const snapshot = issueSnapshotGetter(issueId);
  return (_snapshot$hasMarkups = snapshot === null || snapshot === void 0 ? void 0 : snapshot.hasMarkups) !== null && _snapshot$hasMarkups !== void 0 ? _snapshot$hasMarkups : false;
});
const getIsIssueThumbnailFieldMounted = exports.getIsIssueThumbnailFieldMounted = (0, _toolkit.createSelector)(getIssueSnapshot, issueSnapshotGetter => issueId => {
  var _snapshot$mounted;
  const snapshot = issueSnapshotGetter(issueId);
  return (_snapshot$mounted = snapshot === null || snapshot === void 0 ? void 0 : snapshot.mounted) !== null && _snapshot$mounted !== void 0 ? _snapshot$mounted : false;
});
const getIsAnySnapshotInProgress = exports.getIsAnySnapshotInProgress = (0, _toolkit.createSelector)(getIssueSnapshotsState, snapshotsState => {
  return (0, _some.default)(snapshotsState.snapshotMap, snapshot => snapshot.markingUp || snapshot.status && (snapshot.status === SnapshotsStatus.Capturing || snapshot.status === SnapshotsStatus.Uploading));
});
const getIsPersistingIssueSnapshot = exports.getIsPersistingIssueSnapshot = (0, _toolkit.createSelector)(getIssueSnapshotStatus, issueSnapshotStatusGetter => issueId => {
  const issueSnapshotStatus = issueSnapshotStatusGetter(issueId);
  return !!issueSnapshotStatus && (issueSnapshotStatus === SnapshotsStatus.Capturing || issueSnapshotStatus === SnapshotsStatus.Uploading);
});

/**
 * Return whether we should fetch the snapshot from the server.
 */
const getShouldFetchSnapshot = exports.getShouldFetchSnapshot = (0, _toolkit.createSelector)(getIssueSnapshot, issueSnapshotGetter => issue => {
  // Should download only if the issue has a snapshot urn
  if (!(issue !== null && issue !== void 0 && issue.snapshotUrn)) {
    return false;
  }

  // Get snapshot from cache
  const issueSnapshot = issueSnapshotGetter(issue.id);

  // Issue snapshot is not in cache then need to download
  if (!issueSnapshot) {
    return true;
  }

  // Should download in case the snapshot is not fully cached (probably due to an error)
  if (issueSnapshot.status === SnapshotsStatus.None) {
    return true;
  }

  // Should download only persisted snapshots, not during upload
  if (issueSnapshot.status !== SnapshotsStatus.Persisted) {
    return false;
  }

  // Should download only if the server has a more updated data
  if (issueSnapshot.updatedAt && issue.updatedAt && issueSnapshot.updatedAt > Date.parse(issue.updatedAt)) {
    return false;
  }

  // Should download only if the urn is different
  return issueSnapshot.urn !== issue.snapshotUrn;
});
//# sourceMappingURL=issueSnapshots.js.map